import { render, staticRenderFns } from "./WyhSettingBank.vue?vue&type=template&id=1b084ec0&scoped=true&"
import script from "./WyhSettingBank.vue?vue&type=script&lang=js&"
export * from "./WyhSettingBank.vue?vue&type=script&lang=js&"
import style0 from "./WyhSettingBank.vue?vue&type=style&index=0&id=1b084ec0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b084ec0",
  null
  
)

export default component.exports